import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80b4e550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loadeerr" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader-wrapper" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "brand" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Cap"),
    /*#__PURE__*/_createElementVNode("span", null, "rock")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "loading-bar" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}